import React, { useEffect, useState } from "react";
import PerformanceDashboardFilter from "./PerformanceDashboardFilter/PerformanceDashboardFilter";
import PerformanceDashboardOverallScore from "./PerformanceDashboardOverallScore/PerformanceDashboardOverallScore";
import PerformanceDashboardRatedTable from "./PerformanceDashboardRatedTable/PerformanceDashboardRatedTable";
import PerformanceDashboardRealData from "./PerformanceDashboardRealData/PerformanceDashboardRealData";
import "./PerformanceDashboard.css";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import { PageSpeedPerformanceDashboardEndPointLogic } from "../../../../../logic/AssetManagement/Health/Page Speed Performance/PageSpeedPerformanceDashboardEndPointLogic";
import { useDispatch } from "react-redux";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Link from "@mui/material/Link";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import { Box } from "@mui/system";
import dayjs from "dayjs";
import quarterOfYear from "dayjs/plugin/quarterOfYear";
import SimpleBackdrop from "../../../../BackDrop/BackDrop";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectUserToken } from "../../../../../features/userSlice";
import {
  setDisplay,
  setExequteQueryCompareQuery,
  setExequteQueryCompareQuery4,
  setExequteQueryContent,
  setExequteQueryContentQuery2,
  setExequteQueryContentQuery3,
  setExequteQueryContentQuery4,
  setExequteQueryContentQuery5,
  setExequteQueryContentQuery6,
  setOpenModal,
  setDevice,
  setQuarter,
  setSelectedInterval,
  setSelectedPeriod,
  setSelectedPriode,
} from "../../../../../features/pageSpeedPerformanceSlice";
dayjs.extend(quarterOfYear);
interface PerformanceDashboardProps {
  value: any;
  setValue: any;
}

const PerformanceDashboard = ({ setValue }: PerformanceDashboardProps) => {
  const oauthTokenHeader = useSelector(selectUserToken) as any;
  const {
    selectedSharedUid,
    exequteQueryContent,
    exequteQueryCompareQuery,
    exequteQueryContentQuery2,
    exequteQueryContentQuery3,
    exequteQueryContentQuery4,
    exequteQueryCompareQuery4,
    exequteQueryContentQuery5,
    exequteQueryContentQuery6,
    selectedPage,
    display,
    isInitialized,
    selectedPeriod,
    device,
    quarter,
    selectedPriode,
  } = useSelector((state: any) => state.pageSpeedPerformance);
  const [searchParams, setSearchParams] = useSearchParams();
  const quarters = [
    { label: "Q1", startMonth: 1, endMonth: 3 },
    { label: "Q2", startMonth: 4, endMonth: 6 },
    { label: "Q3", startMonth: 7, endMonth: 9 },
    { label: "Q4", startMonth: 10, endMonth: 12 },
  ];
  const devices = [{ label: "Mobile" }, { label: "Desktop" }];
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const years = Array.from(
    { length: 13 },
    (_, i) => currentYear - 10 + i
  ).reverse(); // Create an array of 13 years starting from 10 years ago
  const currentMonthIndex = currentDate.getMonth();
  const months = [
    { label: "January" },
    { label: "February" },
    { label: "March" },
    { label: "April" },
    { label: "May" },
    { label: "June" },
    { label: "July" },
    { label: "August" },
    { label: "September" },
    { label: "October" },
    { label: "November" },
    { label: "December" },
  ];
  const dispatch = useDispatch();
  const [expanded, setExpanded] = React.useState<string | false>(false);
  const [year, setYear] = useState<any>(currentYear);
  const [month, setMonth] = useState(months[currentMonthIndex]);
  const [show, setShow] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const QUERY_ID = 6658904796692480;
  const QUERY_ID_2 = 5736741495373824;
  const QUERY_ID_3 = 5173791541952512;
  const QUERY_ID_4 = 4618211215540224;
  const QUERY_ID_5 = 6299691448795136;
  const QUERY_ID_6 = 4892316565241856;
  const generateQuarterOptions = (
    pastQuarters: number,
    futureQuarters: number
  ) => {
    const quarters = [];
    const today = dayjs();
    for (let i = -pastQuarters; i <= futureQuarters; i++) {
      const date = today.add(i, "quarter");
      const year = date.year();
      const quarter = date?.quarter();
      quarters.push({
        label: `Q${quarter} ${year}`,
        startMonth: (quarter - 1) * 3 + 1,
        endMonth: quarter * 3,
      });
    }

    return quarters.reverse(); // Reverse to show the most recent quarters first
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [quarterOptions] = useState(generateQuarterOptions(8, 2));
  const yearForMonth = selectedPriode?.year();

  //Function to generate Start Date
  const getFormattedStartDate = () => {
    const yearForMonth = selectedPriode?.year();
    const monthIndex = selectedPriode?.month() + 1;
    if (selectedPeriod === "Quarter" && quarter) {
      const formattedMonth = String(quarter.startMonth).padStart(2, "0");
      return `${year}-${formattedMonth}-01`;
    }
    if (selectedPeriod === "Month") {
      const formattedMonth = String(monthIndex).padStart(2, "0");
      return `${yearForMonth}-${formattedMonth}-01`;
    }
    return null;
  };

  const getFormattedEndDate = () => {
    const yearForMonth = selectedPriode?.year();
    const monthIndex = selectedPriode?.month() + 1; // Get the month (0-indexed, so add 1)
    if (selectedPeriod === "Quarter" && quarter) {
      const lastDay = new Date(year, quarter.endMonth, 0).getDate();
      return `${year}-${String(quarter.endMonth).padStart(2, "0")}-${lastDay}`;
    }
    if (selectedPeriod === "Month") {
      const lastDay = new Date(year, monthIndex, 0).getDate();
      return `${yearForMonth}-${String(monthIndex).padStart(
        2,
        "0"
      )}-${lastDay}`;
    }
    return null;
  };

  const formattedStartDate = getFormattedStartDate(); // Get the formatted start date
  const formattedEndDate = getFormattedEndDate(); // Get the formatted end date

  const handleQuarterChange = (newValue: any) => {
    if (newValue) {
      dispatch(setQuarter(newValue));
      const selectedYear = newValue.label.split(" ")[1]; // Extract year from quarter label
      setYear(selectedYear); // Set the year based on the selected quarter
    } else {
      dispatch(setQuarter(null));
      setYear(currentYear); // Reset to current year if no quarter is selected
    }
  };

  const getPreviousMonth = (currentMonthIndex: any, currentYear: any) => {
    if (currentMonthIndex === 0) {
      // January
      return { month: 11, year: currentYear - 1 }; // December of the previous year
    }
    return { month: currentMonthIndex - 1, year: currentYear }; // Previous month in the same year
  };

  const getPreviousQuarter = (
    currentQuarter: { startMonth: number; endMonth: number },
    currentYear: number
  ) => {
    const previousQuarterIndex =
      quarters.findIndex((q) => q.startMonth === currentQuarter.startMonth) - 1;

    if (previousQuarterIndex < 0) {
      return {
        startMonth: 10,
        endMonth: 12,
        year: currentYear - 1, // Move to Q4 of the previous year
      };
    }

    const previousQuarter = quarters[previousQuarterIndex];
    return {
      ...previousQuarter,
      year: currentYear,
    };
  };

  useEffect(() => {
    const fetchAllData = async () => {
      if (
        isInitialized &&
        formattedStartDate &&
        formattedEndDate &&
        device &&
        show
      ) {
        dispatch(setExequteQueryContent([]));
        dispatch(setExequteQueryCompareQuery([]));
        dispatch(setExequteQueryContentQuery2([]));
        dispatch(setExequteQueryContentQuery3([]));
        dispatch(setExequteQueryContentQuery4([]));
        dispatch(setExequteQueryCompareQuery4([]));
        dispatch(setExequteQueryContentQuery5([]));
        dispatch(setExequteQueryContentQuery6([]));
        try {
          setLoading(true);

          let previousFormattedStartDate = "";
          let previousFormattedEndDate = "";

          if (selectedPeriod === "Month") {
            // Month logic
            const currentMonthIndex = selectedPriode?.month();
            const { month: previousMonthIndex, year: previousYear } =
              getPreviousMonth(currentMonthIndex, yearForMonth);

            previousFormattedStartDate = `${previousYear}-${String(
              previousMonthIndex + 1
            ).padStart(2, "0")}-01`;
            previousFormattedEndDate = `${previousYear}-${String(
              previousMonthIndex + 1
            ).padStart(2, "0")}-${new Date(
              previousYear,
              previousMonthIndex + 1,
              0
            ).getDate()}`;
          } else if (selectedPeriod === "Quarter" && quarter) {
            // Quarter logic
            const previousQuarter = getPreviousQuarter(quarter, year);
            previousFormattedStartDate = `${previousQuarter.year}-${String(
              previousQuarter.startMonth
            ).padStart(2, "0")}-01`;
            previousFormattedEndDate = `${previousQuarter.year}-${String(
              previousQuarter.endMonth
            ).padStart(2, "0")}-${new Date(
              previousQuarter.year,
              previousQuarter.endMonth,
              0
            ).getDate()}`;
          }
          const p1 =
            PageSpeedPerformanceDashboardEndPointLogic.getDashboadExecuteQueries(
              oauthTokenHeader,
              selectedSharedUid,
              formattedStartDate,
              formattedEndDate,
              QUERY_ID,
              device?.label
            );

          const p2 =
            PageSpeedPerformanceDashboardEndPointLogic.getDashboadExecuteQueries(
              oauthTokenHeader,
              selectedSharedUid,
              previousFormattedStartDate,
              previousFormattedEndDate,
              QUERY_ID,
              device?.label
            );

          const p3 =
            PageSpeedPerformanceDashboardEndPointLogic.getDashboadExecuteQueries(
              oauthTokenHeader,
              selectedSharedUid,
              formattedStartDate,
              formattedEndDate,
              QUERY_ID_2,
              device?.label
            );

          const p4 =
            PageSpeedPerformanceDashboardEndPointLogic.getDashboadExecuteQueries(
              oauthTokenHeader,
              selectedSharedUid,
              formattedStartDate,
              formattedEndDate,
              QUERY_ID_3,
              device?.label
            );

          const p5 =
            PageSpeedPerformanceDashboardEndPointLogic.getDashboadExecuteQueries(
              oauthTokenHeader,
              selectedSharedUid,
              formattedStartDate,
              formattedEndDate,
              QUERY_ID_4,
              device?.label
            );

          const p6 =
            PageSpeedPerformanceDashboardEndPointLogic.getDashboadExecuteQueries(
              oauthTokenHeader,
              selectedSharedUid,
              previousFormattedStartDate,
              previousFormattedEndDate,
              QUERY_ID_4,
              device?.label
            );

          const p7 =
            PageSpeedPerformanceDashboardEndPointLogic.getDashboadExecuteQueries(
              oauthTokenHeader,
              selectedSharedUid,
              formattedStartDate,
              formattedEndDate,
              QUERY_ID_5,
              device?.label
            );

          const p8 =
            PageSpeedPerformanceDashboardEndPointLogic.getDashboadExecuteQueries(
              oauthTokenHeader,
              selectedSharedUid,
              formattedStartDate,
              formattedEndDate,
              QUERY_ID_6,
              device?.label
            );
          const results = await Promise.all([p1, p2, p3, p4, p5, p6, p7, p8]);
          results.forEach((res: any, idx: number) => {
            if (!res) return;
            const { id, data } = res;
            // route to right action based on id & which position; be explicit:
            switch (id) {
              case QUERY_ID:
                if (idx === 0)
                  dispatch(setExequteQueryContent({ id, payload: data }));
                // current
                else if (idx === 1)
                  dispatch(setExequteQueryCompareQuery({ id, payload: data })); // previous
                break;
              case QUERY_ID_2:
                dispatch(setExequteQueryContentQuery2({ id, payload: data }));
                break;
              case QUERY_ID_3:
                dispatch(setExequteQueryContentQuery3({ id, payload: data }));
                break;
              case QUERY_ID_4:
                if (idx === 4)
                  dispatch(setExequteQueryContentQuery4({ id, payload: data }));
                if (idx === 5)
                  dispatch(setExequteQueryCompareQuery4({ id, payload: data }));
                break;
              case QUERY_ID_5:
                dispatch(setExequteQueryContentQuery5({ id, payload: data }));
                break;
              case QUERY_ID_6:
                dispatch(setExequteQueryContentQuery6({ id, payload: data }));
                break;
              default:
                console.warn("Unhandled query id", id, "data:", data);
            }
          });
        } catch (error) {
          console.error("Error fetching data:", error);
        } finally {
          setShow(false);
          setLoading(false);
          dispatch(setDisplay(true));
        }
      }
    };
    fetchAllData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    formattedStartDate,
    formattedEndDate,
    selectedPeriod,
    quarter,
    show,
    device,
    isInitialized,
  ]);

  const handleChange = (panel: string) => (_: unknown, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleOpenCreateGoalModal = () => {
    setValue(2);
    dispatch(setOpenModal(true));
    setSearchParams(
      (prevParams) => {
        const updatedParams = new URLSearchParams(prevParams);
        updatedParams.set("tab", "2");
        return updatedParams;
      },
      { replace: true }
    );
  };
  const PageSpecificOverallScores = exequteQueryContentQuery4?.payload
    ?.filter((item: any) => item.page_name === selectedPage?.page_name)
    ?.map((item: any) => item?.Overall_Speed_Performance_Score * 100);
  let OverallScore =
    exequteQueryContent?.payload?.[0]?.Overall_Speed_Performance_Score * 100;
  let AverageOverallScore =
    PageSpecificOverallScores && PageSpecificOverallScores.length > 0
      ? PageSpecificOverallScores.reduce(
          (acc: any, score: any) => acc + score,
          0
        ) / PageSpecificOverallScores?.length
      : 0;
  const handleDeviceChange = (newDevice: any) => {
    dispatch(setDevice(newDevice));
  };

  useEffect(() => {
    setShow(true);
    const params = new URLSearchParams(searchParams.toString());
    const hasDeviceParam = params.get("deviceTab1");
    const hasIntervalParam = params.get("intervalTab1");
    const hasQuarterParam = params.get("quarterTab1");
    const hasSelectedPriodeParam = params.get("selectedPeriodTab1");
    if (selectedSharedUid && !hasDeviceParam) {
      dispatch(setDevice({ label: "Mobile" }));
    }
    if (selectedSharedUid && !hasIntervalParam) {
      dispatch(setSelectedInterval({ label: "Month", value: "month" }));
      dispatch(setQuarter(null));
      dispatch(setSelectedPeriod("Month"));
    }
    if (selectedSharedUid && !hasQuarterParam) {
      dispatch(setQuarter(null));
    }
    if (selectedSharedUid && !hasSelectedPriodeParam) {
      dispatch(setSelectedPriode(dayjs()));
    }
  }, [selectedSharedUid, dispatch, searchParams]);

  return (
    <>
      <PerformanceDashboardFilter
        loading={loading}
        setShow={setShow}
        devices={devices}
        device={device}
        onDeviceChange={handleDeviceChange}
        year={year}
        setYear={setYear}
        months={months}
        month={month}
        setMonth={setMonth}
        setQuarter={handleQuarterChange}
        years={years}
        quarters={quarterOptions}
      />
      {loading ? (
        <SimpleBackdrop />
      ) : (
        <>
          {formattedStartDate &&
            formattedEndDate &&
            Object.keys(exequteQueryContent).length !== 0 &&
            Object.keys(exequteQueryCompareQuery).length !== 0 &&
            Object.keys(exequteQueryContentQuery2).length !== 0 &&
            Object.keys(exequteQueryContentQuery3).length !== 0 &&
            Object.keys(exequteQueryContentQuery4).length !== 0 &&
            Object.keys(exequteQueryCompareQuery4).length !== 0 &&
            Object.keys(exequteQueryContentQuery5).length !== 0 &&
            Object.keys(exequteQueryContentQuery6).length !== 0 &&
            display &&
            !loading && (
              <>
                <Accordion
                  expanded={expanded === "panel1"}
                  onChange={handleChange("panel1")}
                  className="dashboardAccordion"
                  sx={{
                    borderTop: "1px solid #ddd",
                    "&:last-of-type": {
                      borderBottom: "none",
                    },
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                  >
                    <Typography>Quick Look</Typography>
                  </AccordionSummary>
                  <AccordionDetails sx={{ padding: "10px 16px 0px 16px" }}>
                    {isNaN(OverallScore) ||
                    OverallScore === 0 ||
                    OverallScore === null ||
                    OverallScore === undefined ||
                    (selectedPage ? AverageOverallScore : OverallScore) ===
                      0 ? (
                      <Box
                        sx={{
                          width: "100%",
                          backgroundColor: "#FFF4E5",
                          padding: "8px 16px",
                          borderRadius: "4px",
                          border: "1px solid #EE710B",
                        }}
                      >
                        <Typography
                          align="center"
                          color="#EE710B"
                          display="flex"
                          alignItems="center"
                        >
                          <ErrorOutlineOutlinedIcon
                            style={{ marginRight: 5 }}
                          />
                          No goals were set for the selected time period!{" "}
                          <Link
                            onClick={handleOpenCreateGoalModal}
                            style={{
                              fontWeight: "bold",
                              color: "purple",
                              marginLeft: 5,
                              textDecoration: "underline",
                              cursor: "pointer",
                            }}
                          >
                            CLICK HERE
                          </Link>
                          <Typography sx={{ marginLeft: 0.8 }}>
                            {" "}
                            to create new goals.
                          </Typography>
                        </Typography>
                      </Box>
                    ) : (
                      <>
                        <PerformanceDashboardOverallScore
                          OverallScore={OverallScore}
                          AverageOverallScore={AverageOverallScore}
                        />
                        {!selectedPage ? (
                          <PerformanceDashboardRatedTable />
                        ) : null}
                      </>
                    )}
                  </AccordionDetails>
                </Accordion>
                <PerformanceDashboardRealData />
              </>
            )}
        </>
      )}
    </>
  );
};

export default PerformanceDashboard;
